import { LayoutComponent } from './layout.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeModule} from './home/home.module';
import {IndustriesModule} from './industries/industries.module';
import {ServicePageModule} from './service-page/service-page.module';
import {TechnologyModule} from './technology/technology.module';
import {ClienteleModule} from './clientele/clientele.module';
import {AboutModule } from './about/about.module';
import {ContactUsModule} from './contact-us/contact-us.module';
import {GalleryModule} from './gallery/gallery.module';
const routes: Routes = [
  {
    path: '', component: LayoutComponent,
    children: [
      {
      path: '',
      loadChildren: './home/home.module#HomeModule',
    } ,
    {
      path: 'about',
      loadChildren: './about/about.module#AboutModule',
    } ,
    {
      path: 'services',
      loadChildren: './service-page/service-page.module#ServicePageModule',
    } ,
    {
      path: 'industries',
      loadChildren: './industries/industries.module#IndustriesModule',
    } ,
    {
      path: 'technology',
      loadChildren: './technology/technology.module#TechnologyModule',
    } ,
    {
      path: 'client',
      loadChildren: './clientele/clientele.module#ClienteleModule',
    } ,
    {
      path: 'contact',
      loadChildren: './contact-us/contact-us.module#ContactUsModule',
    } ,

    {
      path: 'gallery',
      loadChildren: './gallery/gallery.module#GalleryModule',
    } ,
  ]
  }
]


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
